import React from "react";
import { useAppSelector } from "@/redux-config/hooks";
import { selectUser } from "@/redux-config/entities/user/selector";
import { CustomBreadCrumb } from "@/components/customBreadCrumb";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import "./style.scss";
import { ShoppingBag, User2 } from "lucide-react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useTranslation } from "react-i18next";

export const Home = () => {
  const user = useAppSelector(selectUser);
  const { id } = useParams();

  const { t } = useTranslation();

  const crumbs = [{ name: t("Dashboard"), href: "#" }];

  const data = [
    {
      name: "۲/۶",
      product: 4000,
      services: 2400,
      share: 2400,
      followers: 1398,
      comments: 3000,
    },
    {
      name: "۴/۶",
      product: 3000,
      services: 1398,
      share: 2210,
      followers: 2400,
      comments: 4000,
    },
    {
      name: "۶/۶",
      product: 2000,
      services: 9800,
      share: 2290,
      followers: 2400,
      comments: 1398,
    },
    {
      name: "۸/۶",
      product: 2780,
      services: 3908,
      share: 2000,
      followers: 9800,
      comments: 2400,
    },
    {
      name: "۱۰/۶",
      product: 1890,
      services: 4800,
      share: 2181,
      followers: 2400,
      comments: 4000,
    },
    {
      name: "۱۲/۶",
      product: 2390,
      services: 3800,
      share: 2500,
      followers: 1890,
      comments: 2181,
    },
    {
      name: "۱۴/۶",
      product: 3490,
      services: 4300,
      share: 2100,
      followers: 3800,
      comments: 2181,
    },
    {
      name: "۱۶/۶",
      product: 4300,
      services: 2181,
      share: 2100,
      followers: 1890,
      comments: 2390,
    },
    {
      name: "۱۸/۶",
      product: 5635,
      services: 3123,
      share: 2100,
      followers: 1341,
      comments: 6543,
    },
    {
      name: "۲۰/۶",
      product: 4642,
      services: 2131,
      share: 4532,
      followers: 4567,
      comments: 2543,
    },
  ];

  return (
    <>
      <Helmet>
        <title>MahdiBookShop </title>
        <meta name="description" content="Basic example" />
      </Helmet>
      <div className="d-flex flex-column">
        <CustomBreadCrumb breadCrumbList={crumbs} />
        <div className="d-flex flex-row flex-wrap rounded px-3">
          <div className="col-12  col-sm-6 col-lg-4 p-2">
            <div className="rounded p-3 bg-custom-white h-100 d-flex flex-row justify-content-between">
              <div className="d-flex flex-column">
                <span>{t("UsersActive")} </span>
                <span>0</span>
              </div>
              <User2 />
            </div>
          </div>
          <div className="col-12  col-sm-6 col-lg-4 p-2 ">
            <div className="rounded p-3 bg-custom-white h-100 d-flex flex-row justify-content-between">
              <div className="d-flex flex-column">
                <span>{t("AllUser")}</span>
                <span>0</span>
              </div>
              <span>
                <User2 />
              </span>
            </div>
          </div>

          <div className="col-12  col-sm-6 col-lg-4 p-2">
            <div className="rounded p-3 bg-custom-white h-100 d-flex flex-row justify-content-between">
              <div className="d-flex flex-column">
                <span>{t("SellOrder")}</span>
                <span>0</span>
              </div>
              <ShoppingBag />
            </div>
          </div>
          <div className="col-12 p-2 ">
            <div className="rounded p-3 bg-custom-white h-100 d-flex flex-column flex-sm-row">
              <div className="w-100" dir={"ltr"}>
                <ResponsiveContainer width={"100%"} height={400}>
                  <LineChart
                    data={data}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis yAxisId="left" />
                    <YAxis yAxisId="right" orientation="right" />
                    <Tooltip />
                    <Legend />
                    <Line
                      yAxisId="left"
                      type="monotone"
                      dataKey="product"
                      stroke="#1BC0FF"
                    />

                    <Line
                      yAxisId="left"
                      type="monotone"
                      dataKey="services"
                      stroke="#3BC1A1"
                    />

                    <Line
                      yAxisId="left"
                      type="monotone"
                      dataKey="share"
                      stroke="#FFB11B"
                    />

                    <Line
                      yAxisId="left"
                      type="monotone"
                      dataKey="followers"
                      stroke="#500184"
                    />

                    <Line
                      yAxisId="left"
                      type="monotone"
                      dataKey="comments"
                      stroke="#FF1B52"
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
